import config from '../../../config';

const baseUrl = `${config.apiUrl()}/FleetEntities`;

export default {
  addProfileFleetEntitiesUrl: (): string => `${baseUrl}`,
  editUserFleetEntities: (fleetEntityId): string => `${baseUrl}/${fleetEntityId}`,
};
